import { Card } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { TrendingUp } from "lucide-react";

const PerformanceMetrics = () => {
  return (
    <Card className="p-6 hover:shadow-lg transition-all duration-200">
      <div className="flex items-center justify-between mb-6">
        <div className="space-y-1">
          <h2 className="text-lg font-semibold flex items-center gap-2">
            <TrendingUp className="h-5 w-5 text-green-600" />
            Performance Metrics
          </h2>
          <p className="text-sm text-muted-foreground">Key performance indicators</p>
        </div>
      </div>
      <div className="space-y-6">
        <div className="space-y-2">
          <div className="flex justify-between items-center">
            <span className="text-sm font-medium">Customer Satisfaction</span>
            <span className="text-sm font-medium text-green-600">92%</span>
          </div>
          <Progress value={92} className="h-2" />
        </div>
        <div className="space-y-2">
          <div className="flex justify-between items-center">
            <span className="text-sm font-medium">Order Fulfillment Rate</span>
            <span className="text-sm font-medium text-[#F97316]">85%</span>
          </div>
          <Progress value={85} className="h-2" />
        </div>
        <div className="space-y-2">
          <div className="flex justify-between items-center">
            <span className="text-sm font-medium">Revenue Growth</span>
            <span className="text-sm font-medium text-[#9b87f5]">78%</span>
          </div>
          <Progress value={78} className="h-2" />
        </div>
      </div>
    </Card>
  );
};

export default PerformanceMetrics;